import * as firebase from "firebase/app";
import auth from "firebase/auth";
require('firebase/functions');

const state = {
  currentUser: null,
  loggedIn: false
};

function isInRole(user, role) {
  user.getIdTokenResult(true).then((idTokenResult) => {
    if (idTokenResult.claims.roles.includes(role)) {
      return true;
    } else {
      return false;
    }
  });
}

const actions = {
  login({
    commit,
    state
  }, {
    email,
    password
  }) {
    return new Promise((resolve, reject) => {
      firebase.auth().signInWithEmailAndPassword(email, password)
        .then((result) => {
          if (result) {
            result.user.getIdTokenResult(true).then((idTokenResult) => {
              let admin = idTokenResult.claims.admin;
              if (admin) {
                commit('SET_USER', result.user);
                commit('SET_LOGGED_IN', true);
                resolve(result.user);
              } else {
                reject({
                  message: "user is not an admin"
                });
              }
            });
          }
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  logout({
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      firebase.auth().signOut()
        .then(() => {
          commit('LOGOUT');
          commit('SET_LOGGED_IN', false);
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  authStateChanged({
    dispatch,
    commit,
    state
  }) {
    return new Promise((resolve, reject) => {
      firebase.auth().onAuthStateChanged((user) => {
        if (user) {
          user.getIdTokenResult(true).then((idTokenResult) => {
            //console.log(idTokenResult.claims);
            let admin = idTokenResult.claims.admin;
            if (admin) {
              commit('SET_USER', user);
              commit('SET_LOGGED_IN', true);
              resolve(user);
            } else {
              dispatch("logout");
              resolve(user);
            }
          });
        } else {
          commit('LOGOUT');
          commit('SET_LOGGED_IN', false);
          resolve(user);
        }
      });
    });
  },
  addAdmin({
    commit,
    state
  }, {
    email
  }) {
    return new Promise((resolve, reject) => {
      var addAdmin = firebase.functions().httpsCallable('addAdmin');
      debugger;
      addAdmin({
          email: email
        })
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

const mutations = {
  LOGOUT(state, user) {
    state.currentUser = null;
  },
  SET_USER(state, user) {
    state.currentUser = user;
  },
  SET_LOGGED_IN(state, loggedIn) {
    state.loggedIn = loggedIn;
  }
};

export default {
  state,
  actions,
  mutations,
};